import { render } from "./ClientesViews.vue?vue&type=template&id=39f7f09c&scoped=true"
import script from "./ClientesViews.vue?vue&type=script&lang=js"
export * from "./ClientesViews.vue?vue&type=script&lang=js"

import "./ClientesViews.vue?vue&type=style&index=0&id=39f7f09c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f7f09c"]])

export default __exports__